import styled from 'styled-components'

const Ingredient = styled.div`

  display: flex;
  flex-direction: column;

  margin: 8px;
  @media (max-width: 1120px) {
    margin: 4px;
  }
`

const InredientInfo = styled.div`
  display: flex;
  flex-direction: row;
`

const InredientDetails = styled.div`
  flex: 1 0;
  display: flex;
  flex-direction: column;
`

const Inputs = styled.div`
  flex: 1 0;
  padding-right: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 1120px) {
    padding-right: 8px;
  }

  & > div:first-child {
      margin-right: 10px;
  }
  & > div:last-child {
      margin-left: 10px;
  }
`


const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  flex: 1 1;
`

const Tags = styled.div`
  flex: 1 1;
  padding: 10px 0;
`

const IngredientImage = styled.div`
  padding-left: 16px;
  margin-top: 4px;
  @media (max-width: 1120px) {
    padding-left: 8px;
  }
`

const ButtonsBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 21px;

  & > div:first-child {
    button {
      margin-left: 0;
    }
  }
`

const TranslatesBlock = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 1120px) {
    flex-direction: column;
    margin-bottom: 80px;
  }
`

const TranslatesDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1;
  @media (max-width: 1120px) {
    margin-right: 0;
    padding: 10px 10px 0;
  }
`

const TranslatesDetailsAdditional = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  min-width: 360px;

  @media (max-width: 1120px) {
    margin-left: 0;
    padding: 10px 10px 0;
    min-width: auto;
  }
`

const InputsLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & > div {
    flex: 1 0;
    margin-right: 20px;
  }

  @media (max-width: 1120px) {
    & > div:last-child {
      flex: 1 0;
      margin-right: 0;
    }
  }

  & > img {
    margin: 0 10px;
    height: 44px;
    margin-top: 26px;
    margin-right: 19px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
`

export default {
  Ingredient,
  InredientInfo,
  InredientDetails,
  IngredientImage,
  InputBlock,
  Inputs,
  Tags,
  ButtonsBlock,
  TranslatesBlock,
  TranslatesDetails,
  TranslatesDetailsAdditional,
  InputsLine,
}
